import { Injectable } from "@angular/core";
import { Firestore, collection, query, where, DocumentData } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { BehaviorSubject, Observable, EMPTY, switchMap, distinctUntilChanged } from "rxjs";
import { RestaurantsService } from "./restaurant.service";
import { EventCard } from "src/interfaces/event-card.model"; // Путь до интерфейса Event

@Injectable({
    providedIn: 'root'
})
export class EventCardsService {
    private eventCardsSubject = new BehaviorSubject<EventCard[]>([]);
    public eventCards$ = this.eventCardsSubject.asObservable();
    private cache = new Map<string, EventCard[]>(); // Кеш событий

    constructor(
        private store: Firestore,
        private restaurantsService: RestaurantsService
    ) {
        this.restaurantsService.restaurant$.pipe(
            distinctUntilChanged((prev, curr) => prev?.id === curr?.id), // Исключаем дубликаты
            switchMap((restaurant) => this.getOrFetchShowCards(restaurant?.id ?? ''))
        ).subscribe(eventCards => this.eventCardsSubject.next(eventCards));
    }

    private getOrFetchShowCards(storeId: string): Observable<EventCard[]> {
        if (!storeId) return EMPTY;

        if (this.cache.has(storeId)) {
            return new BehaviorSubject<EventCard[]>(this.cache.get(storeId)!).asObservable();
        }

        return new Observable<EventCard[]>((subscriber) => {
            const eventCardsCollectionRef = collection(this.store, 'events');
            const filteredEventsQuery = query(eventCardsCollectionRef,
                where('active', '==', true),
                where('store', '==', storeId)
            );

            const unsubscribe = collectionData(filteredEventsQuery, { idField: 'id' })
                .subscribe((documents: DocumentData[]) => {
                    // Преобразование данных из Firestore в тип Event[]
                    const eventCards: EventCard[] = documents.map((doc) => ({
                        index: doc["index"],
                        image: doc["image"],
                        thumbImage: doc["thumbImage"],
                        title: doc["title"],
                        description: doc["description"],
                        deadline: doc["deadline"] ? doc["deadline"].toDate() : null,
                        active: doc["active"],
                        store: doc["store"]
                    }));

                    this.cache.set(storeId, eventCards); // Обновляем кеш
                    subscriber.next(eventCards);
                });

            return () => unsubscribe.unsubscribe();
        });
    }
}